import React from "react";
import Popup from "reactjs-popup";
import downloadapp from "../assets/images/download-app.png";
import googleapp from "../assets/images/google-app.png";
import appleapp from "../assets/images/apple-app.png";

const AppDownloadPopup = ({ isAppDownload, setIsAppDownload }) => {
  return (
    <Popup
      open={isAppDownload}
      onClose={() => {
        setIsAppDownload(false);
      }}
      position="right center"
    >
      <>
        <img src={downloadapp} className="h-44 m-auto" />
        <h1 className="text-center text-xl font-bold ">
          This Feature is available on our Mobile app
        </h1>
        <div className="flex justify-center gap-5 mt-10 px-20 py-10">
          <img src={googleapp} className="w-36" />
          <img src={appleapp} className="w-36 " />
        </div>
      </>
    </Popup>
  );
};

export default AppDownloadPopup;
